import React, { memo } from 'react';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';
import { InventoryCardSkeleton } from 'site-modules/personalized-search/components/inventory/inventory-skeleton/inventory-card-skeleton';
import { INVENTORY_SCROLL_TO_TOP_ANCHOR } from 'site-modules/personalized-search/constants/inventory';

import './inventory-skeleton.scss';

export const InventorySkeleton = memo(() => (
  <Container id={INVENTORY_SCROLL_TO_TOP_ANCHOR} className="inventory-skeleton px-1 px-md-0_5 px-lg-0 pt-0_5 pt-md-2">
    <Skeleton className="d-block w-75 height-24 rounded-6" />
    <div className="my-1 d-flex align-items-center">
      <div className="me-0_5 flex-0 px-0_5 py-0_25 rounded-8 bg-cool-gray-70">
        <i className="icon icon-filter text-cool-gray-60 size-14" aria-hidden />
        <Spinner className="ms-0_5" size={13} thickness={2} color="green-50" />
      </div>
      <Skeleton className="ms-auto w-30 rounded-8 height-20" />
    </div>
    <Row>
      {new Array(10).fill(null).map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Col xs={12} md={4} key={index}>
          <InventoryCardSkeleton />
        </Col>
      ))}
    </Row>
  </Container>
));

InventorySkeleton.displayName = 'InventorySkeleton';
